import { createSlice } from '@reduxjs/toolkit';

import { isImpactDebugModeEnabled } from '@/domain/impact/utils/is-impact-debug-mode-enabled';
import { getImpactEnvQuestions } from '@/domain/impact-env/actions/get-impact-env-questions.action';
import { getImpactEnvResponses } from '@/domain/impact-env/actions/get-impact-env-responses.action';
import {
  EnvQuestions,
  EnvQuestionValue,
} from '@/domain/impact-env/entities/question.entity';

export type QuestionsEnvState = {
  questions: EnvQuestions;
  responses: EnvQuestionValue[];
  debugMode: boolean;
};

const initialState: QuestionsEnvState = {
  questions: {},
  responses: [],
  debugMode: isImpactDebugModeEnabled(),
};

export const impactEnvSlice = createSlice({
  name: 'impactEnv',
  initialState,
  reducers: {
    clearImpactAnswers(state) {
      state.questions = {};
    },
  },
  extraReducers(builder) {
    builder
      .addCase(getImpactEnvQuestions.fulfilled, (state, action) => {
        state.questions = action.payload;
      })
      .addCase(getImpactEnvResponses.fulfilled, (state, action) => {
        state.responses = action.payload;
      });
  },
});
